import { render, staticRenderFns } from "./index.vue?vue&type=template&id=106e6dab&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=106e6dab&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106e6dab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('106e6dab')) {
      api.createRecord('106e6dab', component.options)
    } else {
      api.reload('106e6dab', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=106e6dab&scoped=true", function () {
      api.rerender('106e6dab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/order-delivery/index.vue"
export default component.exports